import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'clock-arrow-left',
  size: 24,
  node: [
    ['path', { d: 'M12 6v6l1.5.8', key: 'uc7jki' }],
    ['path', { d: 'M12.338 21.994a10 10 0 1 1 9.587-8.767', key: '1lz5pu' }],
    ['path', { d: 'M14 18h8', key: '1le3fr' }],
    ['path', { d: 'm18 22-4-4 4-4', key: 'dh5o1f' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name ClockArrowLeft
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgNnY2bDEuNS44IiAvPgogIDxwYXRoIGQ9Ik0xMi4zMzggMjEuOTk0YTEwIDEwIDAgMSAxIDkuNTg3LTguNzY3IiAvPgogIDxwYXRoIGQ9Ik0xNCAxOGg4IiAvPgogIDxwYXRoIGQ9Im0xOCAyMi00LTQgNC00IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/clock-arrow-left
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ClockArrowLeft = createLucideIcon(__iconData);

export default ClockArrowLeft;
